import React from 'react';
import { Box, Skeleton, SkeletonCircle, SkeletonText, SimpleGrid, VStack } from '@chakra-ui/react';

export const LoadingSkeleton = ({ type = 'table' }) => {
  if (type === 'cards') {
    return (
      <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={5}>
        {[1, 2, 3, 4].map((i) => (
          <Box key={i} p={5} borderRadius="20px" bg="white" _dark={{ bg: '#161F30' }} boxShadow="sm">
            <SkeletonCircle size="12" mb={4} />
            <SkeletonText noOfLines={2} spacing="3" />
          </Box>
        ))}
      </SimpleGrid>
    );
  }

  return (
    <Box p={5} borderRadius="20px" bg="white" _dark={{ bg: '#161F30' }} boxShadow="sm">
      <VStack spacing={4} align="stretch">
        <Skeleton height="40px" borderRadius="14px" />
        <Skeleton height="20px" borderRadius="8px" />
        <Skeleton height="20px" borderRadius="8px" />
        <Skeleton height="20px" borderRadius="8px" />
        <Skeleton height="20px" borderRadius="8px" />
      </VStack>
    </Box>
  );
};
